module.exports = __webpack_public_path__ + "static/febri-991d9b0b86fbb6662f42da647e92311a.png";